import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DeleteBidderAccountModel } from 'src/app/models/user';
import { AlertService } from 'src/app/services/alert.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog.service';
import { UserService } from 'src/app/services/user.service';

@Component({
    selector: 'app-removebidderaccount',
    templateUrl: './removebidderaccount.component.html',
    styleUrls: ['./removebidderaccount.component.css'],
    standalone: false
})
export class RemovebidderaccountComponent implements OnInit {

  isLoading : boolean = false;

  username : string;
  bidderid : number;

  constructor(
    private alertService: AlertService,
    private confirmService: ConfirmDialogService,
    private userService: UserService,
    private authenticationService: AuthenticationService,
    private router: Router
  ) { 

  var currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
  if (currentUser) {
    this.bidderid = currentUser.bidderid;
    this.username = currentUser.username;
  }
}

  ngOnInit(): void {
  }

  onRemovePressed(){
    this.isLoading = true
    this.confirmService.confirmThis("Are you sure you want to continue?", ()=>{

      var deleteBidderAccountModel : DeleteBidderAccountModel = new DeleteBidderAccountModel();
      deleteBidderAccountModel.BidderId = this.bidderid;

      this.userService.deleteBidderAccount(deleteBidderAccountModel).subscribe((data) => {

        if(data['id'] == 1){
          this.alertService.showSuccess('Account removed successfully');
          this.authenticationService.logout();       
          this.router.navigate(['/login']);
        }else{
          this.alertService.showError(data['result'] ?? 'Error while removing account');
        }

      },
      error => {
        this.alertService.showError(error);
        this.isLoading = false;
      }); 

    }, ()=>{})



    this.isLoading = false;
  }

}
